import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import type { Tone } from "./tone";
import { toneColor } from "./tone";
import { StatusBadge } from "./StatusChip";

export interface KpiItem {
  label: string;
  value: string;
  tone?: Tone;
  /** When true, renders the Under/Near/Over-budget chip beneath the value instead of nothing. */
  showBadge?: boolean;
}

export function KpiCard({ label, value, tone, showBadge }: KpiItem) {
  const badgeTone = tone === "g" || tone === "a" || tone === "r" ? tone : undefined;
  return (
    <Paper variant="outlined" sx={{ p: 1.75, minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 800, mt: 0.5, color: toneColor(tone) }}>
        {value}
      </Typography>
      {showBadge && badgeTone ? (
        <Box sx={{ mt: 0.5 }}>
          <StatusBadge status={badgeTone} />
        </Box>
      ) : null}
    </Paper>
  );
}

export function KpiGrid({ items }: { items: KpiItem[] }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))",
        gap: 1.5,
        mb: 2,
      }}
    >
      {items.map((item, i) => (
        <KpiCard key={item.label + i} {...item} />
      ))}
    </Box>
  );
}
